<template>
  <div class="app-single-top-up-paypal-wrapper">
    <slot name="txtBefore"></slot>
    <div class="success" v-if="showSuccess">
      <slot name="txtBeforeSuccess"></slot>
      {{price(successAmount)}}
    </div>
    <GenericAmountInput
      :amounts="singleTopUpStatus_.amounts.amount"
      :default-amount="singleTopUpStatus_.amounts.default"
      :payment="singleTopUpStatus_.payment"
      v-if="showAmountSelector"
      :loading="loadingInit"
      @amount-select="amountSelect"
    >
      <template v-for="slot in possibleChildSlotsFor('Amount')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </GenericAmountInput>

    <!-- wie fange wir hier fehler ab? es muss eine "zurück" option geben -->
    <oppwa-c-c v-if="showExternalPaypal" available-credit-cards="PAYPAL" :token="token_" :redirect-url="currentUrl">
      <template v-for="slot in possibleChildSlotsFor('Oppwa')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </oppwa-c-c>
    <b-btn v-if="showExternalPaypal && oppwaError"
           variant="secondary"
           @click="resetState"
    >
      Zurück
    </b-btn>

    <SingleTopUpPaypalConfirm :loader="true">
    </SingleTopUpPaypalConfirm>
  </div>
</template>
<script>

import { wrapQuery } from '../../../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'
import transaction from '@/mixins/transaction'
import slotProxy from '../../../../../../mixins/slotProxy'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import SingleTopUpPaypalConfirm from '@/components/process/generic/TopUp/SingleTopUp/PaypalConfirm.vue'
import GenericAmountInput from '@/components/process/generic/TopUp/SingleTopUp/GenericAmountInput.vue'
import OppwaCC from '@/components/generic/OppwaCC.vue'
import configBasedTopUpPrice from '@/mixins/configBasedTopUpPrice'

export default {
  name: 'SingleTopUpPaypalWrapper',
  components: { OppwaCC, GenericAmountInput, SingleTopUpPaypalConfirm },
  props: {
    url: {
      type: String,
      default: '/'
    }
  },
  mounted () {
    // on reload delete success Message
    this.setSuccessAmount(null)
    const comp = this
    // watch for oppwa errors so we can provide a back button
    setInterval(function () {
      comp.oppwaError = document.querySelector('.wpwl-message.wpwl-has-error') !== null
    }, 2500)
  },
  data () {
    return {
      loadingInit: false,
      oppwaError: false,
      singleTopUpStatus: {
        amounts: {
          amount: [],
          default: null
        }
      }
    }
  },
  methods: {
    ...mapActions('topUp/paypal', [
      'prepareSingleTopUpWithPayPal'
    ]),
    ...mapMutations('topUp/paypal', [
      'setSuccessAmount',
      'resetState'
    ]),
    async amountSelect (amount) {
      this.loadingInit = true
      await this.prepareSingleTopUpWithPayPal({ amount })
      this.loadingInit = false
    }
  },
  computed: {
    ...mapGetters('topUp/paypal', [
      'token',
      'step',
      'successAmount',
      'forceOpenAccordion'
    ]),
    showAmountSelector () {
      return this.step === 'amountSelect'
    },
    showExternalPaypal () {
      return this.step === 'paypalConfirm' && this.token && !this.forceOpenAccordion
    },
    token_ () {
      return this.token || null
    },
    showSuccess () {
      return this.successAmount !== null
    },
    slotData () {
      return {
        successAmount: this.successAmount
      }
    },
    singleTopUpStatus_: function () {
      return this.singleTopUpStatus
    },
    currentUrl () {
      return window.location.origin + window.location.pathname
    }
  },
  mixins: [
    transaction('initializePayPalPayment'),
    slotProxy(),
    configBasedTopUpPrice
  ],
  apollo: {
    singleTopUpStatus: function () {
      return wrapQuery(
        gql`query singleTopUp {
          singleTopUpStatus (paypal: true) {
            amounts {
              amount
            }
          }
        }`, this, 'singleTopUpStatus', {}, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  }
}
</script>
